import React, { Suspense, useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigationType } from 'react-router-dom';
import { PageSpinner } from '@shared/patterns';

const scrollPositions = new Map<string, number>();

export const ContentFrame: React.FC = () => {
  const location = useLocation();
  const navType = useNavigationType();
  const mainRef = useRef<HTMLElement>(null);

  // Restore or reset scroll on route transition
  useEffect(() => {
    const el = mainRef.current;
    if (!el) return;

    if (navType === 'POP') {
      const saved = scrollPositions.get(location.key) || 0;
      el.scrollTop = saved;
    } else {
      el.scrollTop = 0;
    }
  }, [location.pathname, location.key, navType]);

  const handleScroll = (e: React.UIEvent<HTMLElement>) => {
    scrollPositions.set(location.key, e.currentTarget.scrollTop);
  };

  return (
    <div className="flex-1 min-w-0 flex flex-col h-full overflow-hidden bg-background">
      <main
        ref={mainRef}
        onScroll={handleScroll}
        className="flex-1 overflow-y-auto overscroll-contain w-full pl-[max(0.875rem,var(--safe-left))] pr-[max(0.875rem,var(--safe-right))] py-4 pb-[calc(var(--mobile-nav-total)+1rem)] md:p-6"
      >
        <Suspense fallback={<PageSpinner />}>
          <div key={location.pathname} className="animate-in fade-in-50 duration-150">
            <Outlet />
          </div>
        </Suspense>
      </main>
    </div>
  );
};
